import { defaultTheme } from "react-admin";
import "../../public/css/hm.css";
import { colors } from "@mui/material";
// import "../styles/hm.css";

export const hmDarkTheme = {
  palette: {
    primary: {
      main: "#90caf9",
      hmcolor: "#00ccb1",
      hmdark: "#506070",
      hmlight: "#919faf",
      hmbg: "#f2f7fa",
    },
    secondary: {
      main: "#FBBA72",
      hmcolor: "#00ccb1",
      hmdark: "#506070",
      hmlight: "#919faf",
      hmbg: "#f2f7fa",
    },
    text: {
      secondary: "black",
    },
    mode: "dark" as "dark", // Switching the dark mode on is a single property value change.
  },
  sidebar: {
    width: 200,
  },
  components: {
    ...defaultTheme.components,
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          "&.RaMenuItemLink-active": {
            borderLeft: "3px solid #90caf9",
          },
          border: "1px solid red",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorSecondary: {
          color: "#ffffffb3",
          backgroundColor: "#616161",
        },
        root: {
          left: "55px",
          paddingLeft: "0px",
        },
      },

      ".appbarContainer": {
        width: "100%",
        maxWidth: "100%",
        pl: 0,
      },
      defaultProps: {
        elevation: 1,
      },
    },
  },
};

export const hmLightTheme = {
  palette: {
    primary: {
      main: "#1976d2",
      hmcolor: "#00ccb1",
      hmdark: "#506070",
      hmlight: "#919faf",
      hmbg: "#f2f7fa",
      contrastText: "#fff",
      hmcontrastText: "#76899E",
    },
    secondary: {
      light: "#1976d2",
      main: "#1976d2",
      dark: "#1976d2",
      hmcolor: "#00ccb1",
      hmdark: "#506070",
      hmlight: "#919faf",
      hmbg: "#f2f7fa",
      contrastText: "#fff",
      hmcontrastText: "#76899E",
    },
    text: {
      secondary: "black",
    },
    background: {
      default: "#fcfcfe",
    },
    textFontFamily: "Proxima Nova",
    numberFontFamily: "Roboto",
    fontFamily: "Arial",
    mode: "light" as "light",
    otherSpacing: {
      leftAsideRemove: "189px",
      tableListRemove: "190px",
      leftAsideWidth: "300px",
      tableListWidthRemove: "409px",
      tableTdPadding: "6px", // old value "6px 16px"
      tableTdTextLgWidth: "250px", // old value 200px
      tableTdTextWidth: "150px", // old value 200px
      tableTdDateWidth: "90px", // old value 120px
      tableTdAmountWidth: "90px", // old value 120px
      tableTdSmallWidth: "60px",
      tableTdMiddleWidth: "100px",
      tableTdPhoneWidth: "110px",
      tableTdAppIdWidth: "80px",
      tableTdLoanIdWidth: "100px",
      tableTdUserIdWidth: "80px",
    },
  },
  shape: {
    borderRadius: 10,
  },
  sidebar: {
    width: 200,
  },
  components: {
    ...defaultTheme.components,
    RaMenuItemLink: {
      //main left menu
      styleOverrides: {
        root: {
          border: "none",
          "&.RaMenuItemLink-active": {
            // borderLeft: '3px solid #4f3cc9',
            backgroundColor: "rgb(255 255 255 / 38%)",
          },
          color: "white",
          fontSize: "1rem",
          fontFamily: "Proxima Nova",
          padding: 10,
        },
      },
    },
    RaLogout: {
      //logout button
      styleOverrides: {
        root: {
          color: "red",
          fontSize: "1rem",
        },
      },
    },

    MuiListItemIcon: {
      //icon
      styleOverrides: {
        root: {
          color: "white",
          // padding:'0px 0px 0px 0px'
        },
        icon: {
          // color: 'white',
          // padding:'0px 0px 0px 0px'
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: "none",
        },
        root: {
          border: "1px solid #e0e0e3",
          backgroundClip: "padding-box",
          fontFamily: "Proxima Nova",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorSecondary: {
          color: "#808080",
          backgroundColor: "#fff",
          fontFamily: "Proxima Nova",
        },
        root: {
          left: "55px",
          paddingRight: "55px",
        },
      },
      defaultProps: {
        elevation: 1,
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#f5f5f5",
        },
        barColorPrimary: {
          backgroundColor: "#d7d7d7",
        },
        fontFamily: "Proxima Nova",
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:last-child td": { border: 0 },
          fontFamily: "Proxima Nova",
        },
      },
    },
    MuiLink: {
      //a link
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          // color: "#00CCB1", //hm color
          color: "#1976d2",
          fontSize: "0.875rem",
        },
      },
    },
    RaUserMenu: {
      //a link
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          fontSize: "0.875rem",
        },
        userButton: {
          fontFamily: "Proxima Nova",
          fontSize: "0.875rem",
          minWidth: "500px",
        },
      },
    },
    MuiTypography: {
      //typography
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          fontSize: "1rem",
        },
        body1: {
          color: "black",
          fontSize: "0.875rem",
          fontFamily: "Proxima Nova",
        },
        body2: {
          //typography table body
          color: "black",
          fontSize: "0.875rem",
          fontFamily: "Proxima Nova",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        // paper: {
        //   minWidth: "500px",
        //   maxHeight: "70vh",
        //   height: "70vh",
        //   background: "#e7ade7ff",
        // },
        paperWidthXl: {
          width: "1200px",
          maxWidth: "1200px",
          minWidth: "1200px",
          maxHeight: "800px",
          height: "800px",
          // border: "5px solid #e7ade7ff",
        },
        paperWidthLg: {
          width: "900px",
          maxWidth: "900px",
          minWidth: "900px",
          // minHeight: "800px",
          minHeight: "min(800px, 95vh)", // 取 800px 和 95vh 中较小的那个
          height: "min(800px, 95vh)", // 取 800px 和 95vh 中较小的那个
          maxHeight: "95vh",
          // height: "800px",
          // border: "5px solid blue",
        },
        paperWidthMd: {
          width: "900px",
          maxWidth: "900px",
          minWidth: "900px",
          maxHeight: "500px",
          height: "500px",
          // border: "5px solid green",
        },
        paperWidthSm: {
          width: "900px",
          maxWidth: "900px",
          minWidth: "900px",
          maxHeight: "300px",
          height: "300px",
          // border: "5px solid yellow",
        },
        paperWidthXs: {
          width: "900px",
          maxWidth: "900px",
          minWidth: "900px",
          maxHeight: "220px",
          height: "230px",
          // border: "5px solid red",
        },
      },
    },
    MuiDialogTitle: {
      //dialog title
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          fontSize: "1rem",
          color: "gray",
        },
      },
    },
    MuiDialogContentText: {
      //dialog content text
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          fontSize: "0.875rem",
          color: "black",
        },
      },
    },
    MuiListItemText: {
      //list item text
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          color: "black",
          paddingLeft: "0rem",
        },
        primary: {
          //sub menus
          fontFamily: "Proxima Nova",
          color: "black",
          fontSize: "0.875rem",
          fontWeight: "normal",
        },
        secondary: {
          // fontFamily: "Proxima Nova",
          fontSize: "0.875rem",
          fontFamily: "Roboto",
        },
      },
    },
    RaFilterListItem: {
      //list item button
      styleOverrides: {
        root: {},
        listItemButton: {
          paddingLeft: "0rem",
        },
      },
    },
    MuiTableSortLabel: {
      //table sort header
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          fontSize: "1rem",
          color: "gray",
        },
      },
    },

    RaDatagridHeaderCell: {
      //table cell
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          fontSize: "1rem",
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontFamily: "Proxima Nova",
          fontSize: "1rem",
          color: "gray",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
          fontWeight: "bold",
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          // fontFamily: 'Proxima Nova',
          fontFamily: "Gotham Rounded",
          fontWeight: "bold",
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          fontFamily: "Proxima Nova",
        },
      },
    },
    MuiScopedCssBaseline: {
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
        },
      },
    },

    html: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        color: "black",
      },
    },
    body: {
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
        },
      },
    },
    a: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    div: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    label: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    p: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    span: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    table: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    tr: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    th: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    td: {
      styleOverrides: {
        fontFamily: "Proxima Nova",
      },
    },
    // MuiBox: {
    //     styleOverrides: {
    //         'root': {
    //             width:'100%'
    //         },
    //     },
    // },
    MuiCssBaseline: {
      styleOverrides: `
                 @font-face {
  font-family: 'Proxima Nova';
  src: url('/fonts/ProximaNova/proximanova-regular-webfont.eot');
  src: url('/fonts/ProximaNova/proximanova-regular-webfont.eot?#iefix') format('embedded-opentype'), url('/fonts/ProximaNova/proximanova-regular-webfont.woff2') format('woff2'), url('/fonts/ProximaNova/proximanova-regular-webfont.woff') format('woff'), url('/fonts/ProximaNova/proximanova-regular-webfont.ttf') format('truetype'), url('/fonts/ProximaNova/proximanova-regular-webfont.svg#proximanovaregular') format('svg');
  font-weight: normal;
  font-style: normal; }
            `,
    },
    MuiTooltip: {
      styleOverrides: {
        tooltipPlacementTop: {
          fontFamily: "Proxima Nova",
          backgroundColor: "#f5f5f9",
          // maxWidth: 220,
          fontSize: "0.875rem",
          border: "1px solid #dadde9",
          borderRadius: "5px",
        },
        // hide tooltip
        tooltip: {},
        MuiChip: {
          display: "none",
        },
      },
    },
    "input.uploadfile": {
      styleOverrides: {
        backgroundColor: "red",
        fontFamily: "Proxima Nova",
      },
    },
    RaLayout: {
      styleOverrides: {
        root: {
          // backgroundColor: "#03363d",
        },
        contentWithSidebar: {
          marginLeft: "-40px",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          // color: '#1976d2',
          color: "#03363d",
          "&.iconactive ": {
            // color: '#97a1a3',
            // opacity: "0.5",
            // backgroundColor: "rgba(0, 0, 0, 0.15)",
            // border: "1px solid red",
            // width: "43px",
            // height: "43px",
            // paddingTop: "5px",
            backgroundColor: "#1976d2",
            color: "#ffffff",
            marginBottom: "10px",
          },
          "&.iconinactive": {
            // border: "1px solid #1976d2",
            // width: "43px",
            // height: "43px",
            // paddingTop: "5px",
            // backgroundColor: "rgba(0, 0, 0, 0.05)",
            marginBottom: "10px",
          },
        },
      },
    },
    // RaSidebar-fixed
    RaSidebar: {
      styleOverrides: {
        root: {
          // marginTop: "0px",
          // paddingTop: "50px",
          // height: "100vh",
          // backgroundColor: "#03363d",
        },
      },
    },
    RaSidebarToggleButton: {
      styleOverrides: {
        root: {
          display: "none",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: "0px",
          maxWidth: "100%",
        },
      },
    },
    // MuiCardContent-root:last-child, padding-bottom:0px;
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "10px",
        },
        "root:last-child": {
          paddingBottom: "0px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "0px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          background: "none",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&:first-of-type": {
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          },
          "&:last-of-type": {
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          // color: "red",
        },
        expandIconWrapper: {
          color: "#1976d2",
        },
      },
    },
    RaFilterForm: {
      styleOverrides: {
        root: {
          flex: "0 1 400%",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: "Proxima Nova",
        },
      },
    },
  },
};
